module.exports = __webpack_public_path__ + "img/campus.e97d1257.png";